@if (isReady) {
  <div class="flex flex-column flex-center">
    <h4>{{'BAG.TOWHICHORDER' | translate}}</h4>
    <div class="flex flex-column flex-grow">
      @for (order of orderIds; track order; let i = $index) {
        <ui-button
          [buttonType]="'button'"
          [buttonStyle]="'primary'"
          [block]="true"
          [disabled]="order.IsLocked"
          (click)="onOrderChosen(order.Id)"
          >
          {{ 'BAG.ORDERNAME' | translate: { count: getOrderName(order, i)} }}
        </ui-button>
      }
      <ui-button
        [buttonType]="'button'"
        [buttonStyle]="'primary'"
        [block]="true"
        (click)="onOrderChosen(null)"
        >
        {{ 'BAG.NEWORDER' | translate }}
      </ui-button>
    </div>
  </div>
}